// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pBk6P{position:relative;padding:24px 0 32px;background-color:#fff}@media screen and (min-width:768px){.pBk6P{padding:0;background-color:transparent}}.pBk6P.bGGP7{min-height:258px}@media screen and (min-width:768px){.pBk6P.bGGP7{min-height:190px}}.pBk6P.Y6pam{min-height:422px}.jDwQR{padding:0 16px;margin-top:16px;text-align:center}@media screen and (min-width:768px){.jDwQR{padding:0;margin:24px auto 0}}.oOVhr{width:100%}@media screen and (min-width:768px){.oOVhr{width:auto}}.ohXOK{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "pBk6P",
	"withoutImages": "bGGP7",
	"withImages": "Y6pam",
	"buttonBox": "jDwQR",
	"button": "oOVhr",
	"loader": "ohXOK"
};
module.exports = ___CSS_LOADER_EXPORT___;
